










































































































import { Component, Vue, Watch } from "vue-property-decorator";
import vuetifyToast from 'vuetify-toast';
import { ArrivalDeparture } from "@/components/ArrivalsDepartures/models/ArrivalDeparture";
import './ArrivalsDeparturesPage.scss'
import Destination from "@/components/Passenger/models/Destination";
import moment from 'moment';
import ArrivalDepartureListItem from "@/components/ArrivalsDepartures/components/ArrivalDepartureListItem.vue";
/* tslint:disable-next-line:max-line-length */
import ArrivalsDeparturesDaySelector from "@/components/ArrivalsDepartures/components/ArrivalsDeparturesDaySelector.vue";
import { Passenger } from "@/components/Passenger/models/Passenger";
import DateTimePicker from "@/components/DatetimePicker.vue";
import { ArrivalsDeparturesDay } from '@/components/ArrivalsDepartures/models/ArrivalsDeparturesDay';
import Routes from '@/Routes';
import { Utility } from '@/components/Passenger/models/Utility';
import PassengerEditor from "@/components/Passenger/components/PassengerEditor.vue";
import PassengerDialog from "@/components/Passenger/components/PassengerDialog.vue";
import DateHelper from '@/util/DateHelper';

const todayYMD = new DateHelper().dateYMD(new Date());

@Component({
    // template: require("./ArrivalsDeparturesPage.vue.html"),
    components: {
      DateTimePicker,
      ArrivalDepartureListItem,
      ArrivalsDeparturesDaySelector,
      PassengerEditor,
      PassengerDialog
    },
  })
export class ArrivalsDeparturesPage extends Vue {
   
    $dateHelper: DateHelper;
    isLoading: boolean = true;
    isLoadingTimeout: number;
    
    todayYMD: string = todayYMD;

    search: string = "";
    searchDebounceTimeout: any = null;

    get arrivalsDeparturesIsLoading(): boolean {
      return this.$store.state.arrivalDeparture.pending.arrivalsDepartures
        || this.$store.state.destination.pending.destinations
        || this.$store.state.passenger.pending.arrivalDeparturePassengers;
    }

    @Watch("arrivalsDeparturesIsLoading", {immediate: true})
    onArrivalsDeparturesIsLoadingChange(val, oldVal){
      if (this.isLoadingTimeout){
        clearTimeout(this.isLoadingTimeout);
      }
      // When asset loading starts, wait a short time to hide ui
      // When assets loading stops, wait longer time to show ui
      let timeout = 500;
      if (!val){
        timeout = 100;
      }
      this.isLoadingTimeout = window.setTimeout(() => { 
          this.isLoading = val
        }, 
        timeout
      );
    }
       
    get me() {
      return this.$store.state.user.me;
    }

    get showWeekends() {
        return this.$store.state.user.showWeekends;
    }

    get arrivalsDepartures(): ArrivalDeparture[] {
      return this.$store.state.arrivalDeparture.arrivalsDepartures;
    }

    get arrivalsDeparturesCount(){
        return this.arrivalsDepartures.length;
    }

    get storeArrivalDepartures(): ArrivalDeparture[] {
      return this.$store.state.arrivalDeparture.arrivalsDepartures;
    }

    get destinationArrivalDepartures(): ArrivalDeparture[] {
      return this.selectedDestination 
        ? this.storeArrivalDepartures.filter((t: ArrivalDeparture) => t.placeId === this.routeDestinationId)
        : [];
    }

    get arrivalDepartureDays(): ArrivalsDeparturesDay[] {
      const arrivalDepartureDays: ArrivalsDeparturesDay[] = this.destinationArrivalDepartures
      .reduce(
        (arr: ArrivalsDeparturesDay[], arrivalDeparture: ArrivalDeparture) => {
          const dateId = arrivalDeparture.atYMD;
          let arrivalDepartureDay: ArrivalsDeparturesDay = arr.find(ad => ad.dateId === dateId);
          if (!arrivalDepartureDay){
            arrivalDepartureDay = new ArrivalsDeparturesDay(dateId);
            arrivalDepartureDay.arrivalsDepartures.push(arrivalDeparture);
            return arr.concat(arrivalDepartureDay);
          } else {
            arrivalDepartureDay.arrivalsDepartures.push(arrivalDeparture);
            return arr;
          }
        },
        []
      )
      .filter(ad => ad.isWithinComingWeek)
      .filter(ad => this.showWeekends || !ad.isWeekEndDay)
      if (!arrivalDepartureDays.find(ad => ad.dateId === this.todayYMD )) {
        // Always have today in the list, even if empty
        arrivalDepartureDays.push(new ArrivalsDeparturesDay(this.todayYMD));
      };
      // console.timeEnd("get arrivalDepartureDays() " + this.selectedDestination.id);
      return arrivalDepartureDays;
    }

    get arrivalDepartureDaysVisible(): ArrivalsDeparturesDay[] {
      return ArrivalsDeparturesDay.sortByDate(this.arrivalDepartureDays);
    }

    get arrivalDepartureDay(): ArrivalsDeparturesDay | undefined {
      const arrivalDepartureDay = this.arrivalDepartureDays.find(
        ted => ted.dateId === this.routeDateId
      );
      return arrivalDepartureDay;
    }

    get sortedArrivalDepartureGroups(): ArrivalDeparture[][] {
      return this.arrivalDepartureDay ? this.arrivalDepartureDay.sortedArrivalDepartureGroups : []
    }

    get hasPassengersMatchingSearch(): boolean {
      // console.log("SEARCHING...");
      const result = this.search && 
        this.arrivalDepartureDay && 
        this.arrivalDepartureDay.arrivalsDepartures
          .map((te: ArrivalDeparture) => 
            this.storePassengers.find(p => p.id === te.passengerId)
          )
          .filter(p => p)
          .some(p => 
            p.nameMatchesSearch(this.search)
          );
      // console.log("result:", result)
      return result;
    }
    
    get dateShort(){
        return this.$dateHelper.formatDateShort(this.arrivalDepartureDay.dateId);
    }

    get destinations(): Destination[] {
      return this.$store.state.destination.destinations;
    }

    get selectedDestination(): Destination | undefined {
      return this.destinations.find(d => d.id === this.routeDestinationId);
    }

    get storePassengers(): Passenger[] {
      return this.$store.state.passenger.arrivalDeparturePassengers;
    }
    get arrivalDeparturePassengerIds(): number[] {
      if (! this.arrivalDepartureDay){
        return [];
      }
      return this.arrivalDepartureDay.arrivalsDepartures
        .map(ad => ad.passengerId);
    }
    @Watch("arrivalDeparturePassengerIds", {immediate: true})
    async arrivalDeparturePassengerIdsChanged(val, oldVal){
      await this.getArrivalDeparturePassengersFromApi();
    }

    async getArrivalDeparturePassengersFromApi(){
      await this.$store.dispatch(
        'passenger/getArrivalDeparturePassengers',
        { 
          data: this.arrivalDeparturePassengerIds
        }
      );
    }

    get routeDestinationId(): number {
      return parseInt(this.$store.state.route.params.destinationId, 10);
    }

    @Watch('routeDestinationId', { immediate: true }) async onRouteDestinationIdChanged(val, oldVal) {
      if (this.destinationArrivalDepartures.length === 0){
        try {

          await this.$store.dispatch(
            'arrivalDeparture/getDestinationArrivalDepartures',
            { params: { destinationId: this.routeDestinationId } },
          );

        } catch (e) {
            if ((e as any).response) {
                if ((e as any).response.status === 401) {
                  this.$store.dispatch('auth/authLogout');
                }
            } else {
              console.error(e);
              vuetifyToast.error(this.$i18n.translate("error.api_connection_error", "API connection error."));
            }
        }
      }
    }

    get routeDateId(): string | undefined {
      return this.$store.state.route.params.dateId;
    }

    async created(){

    }

    onSearchInput(val){
      if (this.searchDebounceTimeout){
        clearTimeout(this.searchDebounceTimeout);
      }
      this.searchDebounceTimeout = setTimeout(
        () => {
          this.search = val;
        }, 
        500
      )
    }

    onPassengerClick(event: Event, passenger: Passenger, arrivalDeparture: ArrivalDeparture){
      this.$root.$emit(
        PassengerDialog.EVENT_PASSENGER_DIALOG_SHOW, 
        passenger, 
        { arrivalDeparture }
      )
    }

    async onPassengerSelectClick(event: Event, passenger: Passenger, arrivalDeparture: ArrivalDeparture){
      arrivalDeparture.completed = !arrivalDeparture.completed;
      if (arrivalDeparture.completed){

        try {
          await this.$store.dispatch('arrivalDeparture/setComplete', {data: ArrivalDeparture.toApi(arrivalDeparture)}); 
        } catch (err) {
            vuetifyToast.error(
              this.$i18n.translate(
                'arrivalDeparture.save.error.setComplete', 
                'There was an error when marking the item as complete. Please reload the page and try again.'
              )
            )
            console.error("Error when setting arrivalDeparture as completed:", err);
            arrivalDeparture.completed = !arrivalDeparture.completed;
        }
        
      } else {

        try {
          await this.$store.dispatch(
            'arrivalDeparture/setIncomplete', 
            { data: ArrivalDeparture.toApi(arrivalDeparture) }
          );

        } catch (err) {
          vuetifyToast.error(
            this.$i18n.translate(
              'arrivalDeparture.save.error.setIncomplete', 
              'There was an error when marking the item as incomplete. Please reload the page and try again.'
            )
          )
          console.error("Error when setting arrivalDeparture as incomplete:", err);
          arrivalDeparture.completed = !arrivalDeparture.completed;
        }

      }
      
    }

    beforeDestroy(){
      // Clear intervals and timeouts
      if (this.searchDebounceTimeout){
        clearTimeout(this.searchDebounceTimeout);
      }
  }

}

export default ArrivalsDeparturesPage;
